import React from "react";
import styles from "./index.module.scss";
import pillars from "../../assets/images/three pillars.svg";
import pillerMobileImg from "../../assets/images/infiniminuteMobile.webp";
const WelcomeHeader = () => {

      const renderPillars = () => (
      <div className={styles.pillars_container}>
        <img src={pillars} alt="Three Pillars" className={styles.pillars_image} />
        <img src={pillerMobileImg} alt="Three Pillars Mobile" className={styles.pillars_image_mobile} />
      </div>
    );
  return (
    <div className={styles.headerContainer}>
        {renderPillars()}
      <div className={styles.welcomeContainer}>
      
      <div className={styles.headerSection}>
       <h2 className={styles.title}>Wishing you Most and more...</h2>
       <p className={styles.subtitle}>
         Welcome to infinitheism - a path that inspires breakthroughs!
       </p>
       </div>
       <div className={styles.descriptionSection}>
      <p className={styles.description}>
        Realizing the great hunger in the world for a new way of life,<span className={styles.highlight}> Mahatria</span> divined the path infinitheism.<br /> It is a path that inspires breakthroughs in anyone who ardently desires abundance in any sphere of human endeavor - spiritual, emotional and material by transforming the human spirit to have faith in its humongous, infinite potential.
      </p>
      </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;
